const formTemplateReference = {
    FIELD_EXPRESSION : 1,

    LINKED_FIELD : 2,

    RULE : 3,

    SCORING_RULE : 4,

    SUPPLEMENTAL_FORM : 5,

    DYNAMIC_DATA_SET : 6

};

angular.module('gw-um-j2js')
    .constant('formTemplateReference', formTemplateReference);